import React, { useState } from 'react'
import dayjs, { Dayjs } from 'dayjs'
import Button from '@mui/material/Button'
import { Grid, TextField } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'

import SelectSearch, { IOptionSelect } from '../../../components/SelectSearch'
import useAxios from '../../../hooks/useAxios'
import { PaginationResponseInterface } from '../../../types/pagination'
import { IDistributionChannel } from '../../../types/distribution-channel'
import ClearIcon from '@mui/icons-material/Clear'
import ExportExcel from '../../../components/Export'
import ChannelSelectSearch from '../../../components/SelectSearch/ChannelSelectSearch'

export interface IFilterMapped {
  page?: number
  perPage?: number
  name?: string
  distributionChannel?: string
  startDate?: string
  endDate?: string
}

interface FilterGroupProps {
  onFilterChange: (filter: IFilterMapped) => void
  defaultFilter: IFilterMapped
  onDownload?: (date: Dayjs) => void
}

const ExpensesFilter = (props: FilterGroupProps) => {
  const { onFilterChange, defaultFilter, onDownload } = props

  const [filter, setFilter] = useState<IFilterMapped>(defaultFilter ?? [])
  const [searchDistributionChannel, setSearchDistributionChannel] =
    useState<string>('')

  const distributionChannels = useAxios<
    PaginationResponseInterface<IDistributionChannel>
  >({
    method: 'GET',
    url: '/distribution-channels',
    params: {
      page: 1,
      perPage: 5,
      search: searchDistributionChannel,
      startDate: '',
      endDate: '',
    },
  })

  const handleSearchDistributionChannel = async (value: string) => {
    setSearchDistributionChannel(value)
    try {
      await distributionChannels.mutate()
    } catch (error) {}
  }

  return (
    <Grid container spacing={2} mb={2}>
      <Grid item xs={12} lg={6}>
        <TextField
          fullWidth
          label="ชื่อ"
          variant="filled"
          defaultValue={filter.name ?? undefined}
          onChange={(e) => setFilter({ ...filter, name: e.target.value })}
        />
      </Grid>
      <Grid item xs={12} lg={6}>
        {/* <SelectSearch<IDistributionChannel>
          label={'เลือกช่องทางการขาย'}
          onSelect={(e) =>
            setFilter({ ...filter, distributionChannel: e?.value.objectId })
          }
          search={searchDistributionChannel}
          onSearch={handleSearchDistributionChannel}
          options={
            distributionChannels.data?.records.map(
              (distributionChannel: IDistributionChannel) => ({
                label: distributionChannel.name,
                value: distributionChannel,
              }),
            ) || ([] as IOptionSelect<IDistributionChannel>[])
          }
        /> */}
        <ChannelSelectSearch
          multiple={false}
          label={'เลือกช่องทางการขาย'}
          onSelect={(e: any) =>
            setFilter({ ...filter, distributionChannel: e?.value.objectId })
          }
        />
      </Grid>
      <Grid item xs={12} lg={3}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            // disableFuture
            label="เลือกวันที่เริ่มต้น"
            value={filter?.startDate ? dayjs(filter?.startDate) : null}
            onChange={(e) => setFilter({ ...filter, startDate: e?.format() })}
            sx={{ width: '100%' }}
          />
        </LocalizationProvider>
      </Grid>
      <Grid item xs={12} lg={3}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            // disableFuture
            label="เลือกวันที่สิ้นสุด"
            value={filter?.endDate ? dayjs(filter?.endDate) : null}
            onChange={(e) => setFilter({ ...filter, endDate: e?.format() })}
            sx={{ width: '100%' }}
          />
        </LocalizationProvider>
      </Grid>
      <Grid item xs={8} lg={2}>
        <Button
          color="primary"
          size={'large'}
          fullWidth
          variant="contained"
          startIcon={<SearchIcon />}
          onClick={() => {
            onFilterChange(filter)
          }}
          sx={{ height: '100%' }}
        >
          ค้นหา
        </Button>
      </Grid>
      <Grid item xs={4} lg={2}>
        <Button
          color="inherit"
          size="large"
          fullWidth
          variant="contained"
          startIcon={<ClearIcon />}
          onClick={() => onFilterChange({})}
          sx={{ height: '100%' }}
        >
          รีเซ็ต
        </Button>
      </Grid>
      <Grid item xs={12} lg={2}>
        <ExportExcel onDownload={onDownload} />
      </Grid>
    </Grid>
  )
}

export default ExpensesFilter
